export default __webpack_public_path__ + "static/media/AlphabetSort.8f906bcd.svg";